import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedPosition: {},
    positions: [],
  }),

  mutations: {
    setSelectedPosition(state, position) {
      Vue.set(state, "selectedPosition", position);
    },
    setPositions(state, positions) {
      Vue.set(state, "positions", positions);
    },
    setDefaultPositionModule(state, positions) {
      Vue.set(state, "selectedPosition", {});
      Vue.set(state, "positions", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createPosition: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/position-types/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPositions: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/entity").then((response) => {
        context.commit("setPositions", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadPublishedPositions: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/entity/published").then((response) => {
        return response.data;
      });
    },

    loadPositionHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/position-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedPositionHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    searchPositionByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/position-types/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deletePosition: (context, position) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/position-types/entity/" + position.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          position.intents = intents;
          position.intentId = response.data.id;
          return position;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftPosition: (context, position) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/position-types/draft/" + position.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishPosition: (context, position) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/publish/" + position.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectPosition: (context, position) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/reject/" + position.intentId).then((response) => {
        if (position.intents[0].type === "DELETE_POSITION_TYPE") {
          position.intents = null;
          position.intentId = 0;
        } else if (position.intents[0].type === "CREATE_POSITION_TYPE") {
          position.intents[0].status = "DRAFT";
        } else if (position.intents[0].type === "UPDATE_POSITION_TYPE") {
          position.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallPositionType: (context, positionType) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/recall/" + positionType.intentId).then((response) => {
        helper.recallOrRejectEntity(positionType, "POSITION_TYPE");
        return response.data;
      });
    },

    cancelPositionType: (context, positionType) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/cancel/" + positionType.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalPositions: (context, position) => {
      return axios.get(context.getters.getMcServiceUrl + "/position-types/sendToApproval/" + position.intentId).then((response) => {
        if (position.intents[0].type === "CREATE_POSITION_TYPE") {
          position.intents[0].status = "WAITING_APPROVAL";
        } else if (position.intents[0].type === "UPDATE_POSITION_TYPE") {
          position.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
  },

  getters: {
    getSelectedPosition: (state) => {
      return state.selectedPosition;
    },
    getPositions: (state) => {
      return state.positions;
    },
    getPublishedPositions: (state) => {
      return state.positions.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
